import { render, staticRenderFns } from "./ReChatMessage.vue?vue&type=template&id=c5adac42&scoped=true"
import script from "./ReChatMessage.vue?vue&type=script&lang=js"
export * from "./ReChatMessage.vue?vue&type=script&lang=js"
import style0 from "./ReChatMessage.vue?vue&type=style&index=0&id=c5adac42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5adac42",
  null
  
)

export default component.exports